class Customer.SignaturesListView extends Backbone.View
  templateHeader: JST["backbone/templates/customer/ticket/signatures/list"]
  templateRow: JST["backbone/templates/customer/ticket/signatures/row"]

  events:
    'click .btn-add': '_createNew'

  initialize: (@options = {}) ->
    @selector = '.signatures-list'
    @searchSignaturesAndRender()

  searchSignaturesAndRender: =>
    data = {}
    $.get('/signatures', data, (response) =>
      @render(response)
    )
    $.get('/signatures/types', data, (response) =>
      @types = response
    )
    $.get('/signatures/labels', data, (response) =>
      @labels = response
    )
    @$el.html(@templateHeader({self: @}))

  render: (data) =>
    $(@selector).append(@$el)
    @$el.html(@templateHeader({self: @}))
    $(@selector).append(@$el)
    @tbody = @$el.find('tbody')
    @renderList(data)
    @

  renderList: (signatures) =>
    @tbody.empty()
    _.each signatures, (s) =>
      @appendRow(s)

  appendRow: (s) =>
    row = $(@templateRow({self: @, model: s}))
    row.find(".action-delete").on('click', s, @_destroy)
    row.find(".action-edit").on('click', s, @_edit)
    row.find(".action-preview").on('click', s, @_openPreview)
    @tbody.append(row)

  _destroy: (ev)=>
    @signature = ev.data
    swal({
        title: 'This signature will be deleted. Are you sure?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: 'Yes',
        closeOnConfirm: true
      }, (isConfirm) =>
        if isConfirm
          $.ajax(
            url: '/signatures/delete'
            type: 'DELETE'
            data: @signature
            success: (response) =>
              if response["success"]
                $("#signature-" + @signature.id).remove()
          )
    )

  _edit: (ev) =>
    return if not @types
    model = ev.data
    new Customer.SignatureEditorView({new: false, model: model, types: @types, labels: @labels, caller: @})

  _openPreview: (ev) =>
    model = ev.data
    container = @$el.find('#preview-modal')
    @previewView = new Customer.SignaturePreviewView({ container: container, text: model.text, text_html: model.text_html })

  _createNew: =>
    return if not @types
    default_model = {active: true, text: "", types: [], labels: []}
    new Customer.SignatureEditorView({new: true, model: default_model, types: @types, labels: @labels, caller: @})

  appendNewSignature: (model) =>
    @appendRow(model)

  updateSignature: (model) =>
    $("#signature-" + model.id).remove();
    @appendNewSignature(model)
